import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_freedom_pay_event.js";
//#region src/bite_log_freedom_pay_event_helper.ts
var bite_log_freedom_pay_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "payment-success";
		case 2: return "payment-error";
		case 3: return "refund-success";
		case 4: return "refund-error";
		case 5: return "reverse-refund-attempt";
		case 6: return "tokenization-error";
		case 7: return "iframe-init-error";
		case 8: return "terminal-disconnected";
		case 9: return "update-idle-text-error";
		case 10: return "auth-transaction";
		case 11: return "auth-transaction-error";
		case 12: return "sale-transaction";
		case 13: return "sale-transaction-error";
		case 14: return "logs";
		case 15: return "install-pal";
		case 16: return "install-pal-error";
		case 17: return "terminal-connected";
		case 18: return "perform-maintenance";
		case 19: return "native-transaction";
		case 20: return "native-transaction-error";
		case 22: return "replay-transaction";
		case 23: return "replay-transaction-error";
		case 21: return "command-sync";
		case 24: return "qr-code-generate";
		case 25: return "qr-code-generate-error";
		case 26: return "token-retrieve";
		case 27: return "token-retrieve-error";
	}
}
//#endregion
export { bite_log_freedom_pay_event_helper_exports, name };

//# sourceMappingURL=bite_log_freedom_pay_event_helper.js.map